import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Divider, Drawer, Link, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useAuth from '../../../hooks/useAuth';
import Logo from '../../Logo';
import NavSection from '../../NavSection';
import Scrollbar from '../../Scrollbar';
import AddIcon from '@material-ui/icons/Add';





import useMounted from '../../../hooks/useMounted';

const FeaturesSidebar = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const { user } = useAuth();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const mounted = useMounted();



   // http://localhost:3001/features/project/4cca3739-0644-4928-a7c9-2fec268e1cb9/feature/279abda5-039e-4a50-9e6a-867d125f2b87
   const projectId = window.location.href.split('features/project/')[1].split('/feature/')[0]
   const projectName = ''



  const [features, setFeatures] = useState(null);
  
  useEffect(() => {
    setFeatures(props.featuresMenu);
  });


  if (!features) {
    return null;
  }


  const add = () => {

  };


  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Scrollbar options={{ suppressScrollX: true }}>
        <Box
          sx={{
            display: {
              lg: 'none',
              xs: 'flex'
            },
            justifyContent: 'center',
            p: 2
          }}
        >
          <RouterLink to="/">
            <Logo
              sx={{
                height: 40,
                width: 40
              }}
            />
          </RouterLink>
        </Box>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'background.default',
              borderRadius: 1,
              display: 'flex',
              overflow: 'hidden',
              p: 2
            }}
          >
            <Box sx={{ ml: 2 }}>
              <Typography
                color="textPrimary"
                variant="subtitle2"
              >
                <Link
                  color="error"
                  component={RouterLink}
                  to={"/dashboard/projects/" + projectId}
                >
                  Back to the working project
                </Link>
              </Typography>
              <Typography
                color="textSecondary"
                variant="body2"
              >
                Working project :
                {' '}
                {props.projectName}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        

          <Button
                  color="primary" color="success"
                  component={RouterLink}
                  startIcon={<AddIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  // to={"/features/project/" + project.id + ":" + project.name}
                  to={"/features/project/" + projectId + "/feature/new"}
                  variant="contained"
                >
                  Add new feature
            </Button>

        
        <Divider />

        <Box sx={{ p: 2 }}>
          {features.map((section) => (
            <NavSection
              key={section.title}
              pathname={location.pathname}


              sx={{
                '& + &': {
                  mt: 3
                }
              }}
              {...section}
            />
          ))}
        </Box>

      </Scrollbar>
    </Box>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            height: 'calc(100% - 64px) !important',
            top: '64px !Important',
            width: 280
          }
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 280
        }
      }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

FeaturesSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default FeaturesSidebar;
